export default __webpack_public_path__ + "static/media/image-six.33eaa8ba.jpg";